export class MachineBag {
    machineId: number;
    bagId: string;
    bagPosition: number;

    constructor() {}

    parse(obj: any) {
        if (obj.MachineId != null) this.machineId = obj.MachineId;
        if (obj.BagId != null) this.bagId = obj.BagId;
        if (obj.BagPosition != null) this.bagPosition = obj.BagPosition;
    }
}
